import React, { useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import { PrelevementContext } from '../../PrelevementContext'
import PrelevementFinancialInfoForm from './PrelevementFinancialInfoForm'
import { FinancialPrelevementInfoModel } from '../../../profileModel'
import fetchFactory from '../../../../../utils/fetchFactory'
import { configEnum } from '../../../../../enums/fetchFactoryEnum'
import { sendToSign } from '../../../profileMapper'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import { FormErrorEnum } from "../../../../../enums/errorsTypeEnum";

interface AcceptingProps {
    setError: (error?: string) => void
}

type PrelevementFinancialInfoProps = AcceptingProps

const PrelevementFinancialInfo: React.FC<PrelevementFinancialInfoProps> =
    ({
         setError
     }) => {
        const { prelevement, nextStep, previousStep } = useContext(PrelevementContext)
        const intl = useIntl()
        const [loading, setLoading] = useState<boolean>(false)

        const onSubmit = (values: FinancialPrelevementInfoModel) => {
            setLoading(true)
            return fetchFactory(
                `/api/ec_${process.env.REACT_APP_TARGET}/prelevement_sepa/signSepa`,
                {
                    body: JSON.stringify(sendToSign({
                        ...prelevement,
                        financialInfo: values
                    })),
                    method: configEnum.post
                }
            )
                .then((response: any) => {
                    saveInteractions(
                        {
                            category: 'Mes Services',
                            action: 'Souscrire en ligne',
                            label: 'Mes Services::Souscrire en ligne::etape2::ok'
                        }
                    )

                    nextStep(response)
                })
                .catch(
                    (err) => {
                        previousStep()
                        if (!!err['content'] && !!err['content']['errorType']
                            && (err['content']['errorType'] === FormErrorEnum.DQE
                            || err['content']['errorType'] === FormErrorEnum.file)
                        ) {
                            setError(intl.formatMessage({
                                id: err['content']['id'],
                                defaultMessage: err['content']['defaultMessage'],
                                description: `Error during submission : ${err['content']['key']}`
                            }))

                        }
                        else {
                            setError(intl.formatMessage({
                                id: err || 'profile.prelevement.step1.errorPhone',
                                defaultMessage: 'Une erreur est survenue, veuillez verifier votre numéro de téléphone',
                                description: 'Error phone'
                            }))
                        }

                    }
                )
                .finally(() => {
                    setLoading(false)
                })

        }

        const validate = (values: FinancialPrelevementInfoModel) => {
            const errors: any = {}

            if (!values.iban) {
                errors.iban = intl.formatMessage(
                    {
                        id: 'global.errors.required',
                        defaultMessage: 'Requis*',
                        description: 'Required message'
                    }
                )
            }
            if (!values.bic) {
                errors.bic = intl.formatMessage(
                    {
                        id: 'global.errors.required',
                        defaultMessage: 'Requis*',
                        description: 'Required message'
                    }
                )
            }
            if (!values.rib || Object.keys(values.rib).length === 0) {
                errors.rib = intl.formatMessage(
                    {
                        id: 'global.errors.required',
                        defaultMessage: 'Requis*',
                        description: 'Required message'
                    }
                )
            }
            return errors
        }
        return (
            <PrelevementFinancialInfoForm
                onSubmit={onSubmit}
                validate={validate}
                loading={loading}
            />
        )
    }


export default PrelevementFinancialInfo